import { Credential, Logger, NotFoundError } from '@uploadcam/common';
import { CREDENTIALS_KEY } from './login-with-popup.interactor';

export class GetCredentialInteractor {
  constructor(
    private readonly logger: Logger,
    private readonly storage: Storage,
  ) {}

  public execute(): Credential {
    const credsRaw = this.storage.getItem(CREDENTIALS_KEY);

    if (!credsRaw) {
      throw new NotFoundError('Credential not found in storage.');
    }

    const credsJSON = JSON.parse(credsRaw);
    const { authType, provider, accessToken, refreshToken, expiresAt, scopes, metadata } =
      credsJSON;

    const credential = new Credential(
      authType,
      provider,
      accessToken,
      expiresAt,
      refreshToken,
      scopes,
      metadata,
    );

    this.logger.info(`Credential expires at: ${new Date(credential.expiresAt)}.`);

    return credential;
  }
}
